import { z } from 'zod'

export const Contract = z.object({
  id: z.number(),
  personId: z.string(),
  name: z.string(),
  location: z.string().nullable(),
  password: z.string().nullable(),
  active: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export const ContractRenovation = z.object({
  id: z.number(),
  contractId: z.number(),
  description: z.string().nullable(),
  startAt: z.coerce.date(),
  finishAt: z.coerce.date(),
  active: z.boolean(),
})

export const Equipment = z.object({
  id: z.string(),
  name: z.string(),
  manufacturer: z.string().nullable(),
  about: z.string().nullable(),
  type: z.enum(['EQUIPAMENTO', 'BATERIA']),
  imageStr: z.string().nullable(),
  active: z.boolean(),
  // createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export const EquipmentVista = z.object({
  id: z.string(),
  equipmentId: z.string(),
  name: z.string(),
  imageStr: z.string().nullable(),
  updatedAt: z.coerce.date(),
})

export const EquipmentVistaItem = z.object({
  id: z.string(),
  vistaId: z.string(),
  vistaIndex: z.number(),
  productId: z.string(),
})

export const Asset = z.object({
  id: z.string(),
  assetNumber: z.string(),
  serialNumber: z.string().nullable(),
  boughtAt: z.coerce.date(),
  manufacturedAt: z.coerce.date(),
  warrantyExpiresAt: z.coerce.date(),
  isRefurbished: z.boolean(),
  inMaintenance: z.boolean(),
  active: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export const Person = z.object({
  id: z.string(),
  name: z.string(),
  nickname: z.string().nullable(),
  document: z.string(),
  personType: z.enum(['FISICA', 'JURIDICA', 'OUTRA']),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  active: z.boolean(),
})

export const PersonAddress = z.object({
  id: z.string(),
  personId: z.string(),
  zipCode: z.string(),
  address: z.string(),
  number: z.string().nullable(),
  extra: z.string().nullable(),
  zone: z.string(),
  city: z.string(),
  unit: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  active: z.boolean(),
})

export const PersonContact = z.object({
  id: z.string(),
  personId: z.string(),
  name: z.string(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  role: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  active: z.boolean(),
})

export const Product = z.object({
  id: z.string(),
  name: z.string(),
  sku: z.string(),
  manufacturer: z.string().nullable(),
  productType: z.enum(['PRODUTO', 'SERVICO']),
  supplierId: z.string().nullable(),
  buyPrice: z.number(),
  sellPrice: z.number(),
  active: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export const OrderStatus = z.enum([
  'OPEN',
  'FIM_ORCAMENTO',
  'APPROVED',
  'DOING',
  'DONE',
  'CLOSED',
  'REPROVED',
  'CANCELED',
])

export const Order = z.object({
  id: z.number(),
  type: z.enum(['SERVICO', 'VENDA']),
  status: OrderStatus,
  location: z.enum(['INTERNAL', 'EXTERNAL']),
  payment: z.string().nullable(),
  delivery_date: z.coerce.date().nullable(),
  blockType: z.enum(['MISSING_PARTS']).nullable(),

  person_id: z.string(),
  person_name: z.string(),
  person_nickname: z.string().nullable(),
  person_document: z.string(),
  person_address: z.string().nullable(),
  person_contact: z.string().nullable(),
  person_email: z.string().nullable(),

  equipment_name: z.string().nullable(),
  equipment_serial: z.string().nullable(),
  equipment_id: z.string().nullable(),
  equipment_manufacturer: z.string().nullable(),
  equipment_accessories: z.string().nullable(),

  defect: z.string().nullable(),
  defect_found: z.string().nullable(),
  tech_user_id: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
})

export const OrderConsumedItem = z.object({
  order_id: z.number(),
  item_id: z.string(),
  quantity: z.number(),
  item_name: z.string(),
  item_sku: z.string(),
  item_manufacturer: z.string().nullable(),
  item_b_price: z.number(),
  item_s_price: z.number(),
})

export const OrderItemType = z.enum(['PRODUTO', 'SERVICO', 'EQUIPAMENTO'])

export const OrderItem = z.object({
  id: z.string(),
  order_id: z.number(),
  order_report_id: z.number().nullable(),
  type: OrderItemType,
  name: z.string(),
  manufacturer: z.string().nullable(),
  product_id: z.string().nullable(),
  product_sku: z.string().nullable(),
  equipment_id: z.string().nullable(),
  equipment_serial: z.string().nullable(),
  buy_price: z.number(),
  sell_price: z.number(),
  quantity: z.number(),
})

export const Storage = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  active: z.boolean(),
})

export const StorageItem = z.object({
  storage_id: z.string(),
  item_id: z.string(),
  quantity: z.number(),
  rule_min_quantity: z.number(),
  updated_at: z.coerce.date(),
})

// prettier-ignore
export const StorageTransaction = z.object({
  id:                z.number(),
  target_order_id:   z.number().nullable(),
  origin_order_id:   z.number().nullable(),
  target_storage_id: z.string().nullable(),
  origin_storage_id: z.string().nullable(),
  item_id:           z.string(),
  quantity:          z.number(),
  description:       z.string().nullable(),
  user_id:           z.string(),
  created_at:        z.coerce.date(),
  item_name:         z.string(),
  item_sku:          z.string(),
  item_manufacturer: z.string().nullable(),
  item_b_price:      z.number(),
  item_s_price:      z.number(),
})

export const User = z.object({
  id: z.string(),
  username: z.string(),
  displayName: z.string(),
  active: z.boolean(),
  role: z.enum(['ADMIN', 'USER']),
})
